import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSTipoPedidoEstabOrigemService from '@/services/SistemaDKP/SLSTipoPedidoEstabOrigem.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSTipoPedidoEstabOrigemService = new SLSTipoPedidoEstabOrigemService();
  const refTipoPedidoEstabOrigemListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'tipopedidoid', label: 'Tipo Pedido', sortable: false },
    { key: 'estabelecimentoid', label: 'Estabelecimento', sortable: true },
    { key: 'itemorigem', label: 'Origem', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalTipoPedidoEstabOrigem = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('tipopedidoid');
  const isSortDirDesc = ref(false);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refTipoPedidoEstabOrigemListTable.value ? refTipoPedidoEstabOrigemListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTipoPedidoEstabOrigem.value,
    };
  });

  const refetchData = () => {
    if (refTipoPedidoEstabOrigemListTable.value && typeof refTipoPedidoEstabOrigemListTable.value.refresh === 'function') {
      refTipoPedidoEstabOrigemListTable.value.refresh();
    } else {
      console.warn('refTipoPedidoEstabOrigemListTable não está inicializado ou não possui o método refresh.');
    }
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const create = async (body) => {
    try {
      await sLSTipoPedidoEstabOrigemService.store(body);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Origem cadastrada com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      console.error('Erro ao cadastrar Origem.', error);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Erro ao cadastrar Origem.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };

  const Updated = async (body) => {
    const response = await sLSTipoPedidoEstabOrigemService.update(body);
    if (response) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Origem atualizada com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    } else {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Origem não foi atualizada.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
    refetchData();
  };

  const removerData = async (data) => {
    await sLSTipoPedidoEstabOrigemService.destroy(data);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    tableColumns,
    perPage,
    currentPage,
    totalTipoPedidoEstabOrigem,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTipoPedidoEstabOrigemListTable,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    Updated,
    create,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
